// extracted by mini-css-extract-plugin
module.exports = {"quickSettings":"QuickSettings_quickSettings__1LBl0"};